import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appImageRotation]'
})
export class ImageRotationDirective implements OnChanges {

  @Input() data: any;
  private domElement: HTMLElement;

  constructor(private renderer: Renderer2,
    private elementRef: ElementRef) {
    this.domElement = this.elementRef.nativeElement as HTMLElement;
  }

  ngOnChanges(): void {
    this.setRotation();
  }

  setRotation() {
    const image = this.domElement;
    if (image) {
      if (Number(this.data) === 90 || Number(this.data) === 270) {
        this.renderer.setStyle(
          image,
          'transform',
          `rotate(${this.data}deg) scale(0.5)`
        );
      }
      else {
        this.renderer.setStyle(
          image,
          'transform',
          `rotate(${this.data}deg)`,
        );
      }
    }
  }


}
